import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/frechet/cdf';
import __var_2__ from '@stdlib/stats/base/dists/frechet/ctor';
import __var_3__ from '@stdlib/stats/base/dists/frechet/entropy';
import __var_4__ from '@stdlib/stats/base/dists/frechet/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/frechet/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/frechet/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/frechet/mean';
import __var_8__ from '@stdlib/stats/base/dists/frechet/median';
import __var_9__ from '@stdlib/stats/base/dists/frechet/mode';
import __var_10__ from '@stdlib/stats/base/dists/frechet/pdf';
import __var_11__ from '@stdlib/stats/base/dists/frechet/quantile';
import __var_12__ from '@stdlib/stats/base/dists/frechet/skewness';
import __var_13__ from '@stdlib/stats/base/dists/frechet/stdev';
import __var_14__ from '@stdlib/stats/base/dists/frechet/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace frechet
*/
var frechet = {};

/**
* @name cdf
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/cdf}
*/
setReadOnly( frechet, 'cdf', __var_1__);

/**
* @name Frechet
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/ctor}
*/
setReadOnly( frechet, 'Frechet', __var_2__);

/**
* @name entropy
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/entropy}
*/
setReadOnly( frechet, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/kurtosis}
*/
setReadOnly( frechet, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/logcdf}
*/
setReadOnly( frechet, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/logpdf}
*/
setReadOnly( frechet, 'logpdf', __var_6__);

/**
* @name mean
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/mean}
*/
setReadOnly( frechet, 'mean', __var_7__);

/**
* @name median
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/median}
*/
setReadOnly( frechet, 'median', __var_8__);

/**
* @name mode
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/mode}
*/
setReadOnly( frechet, 'mode', __var_9__);

/**
* @name pdf
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/pdf}
*/
setReadOnly( frechet, 'pdf', __var_10__);

/**
* @name quantile
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/quantile}
*/
setReadOnly( frechet, 'quantile', __var_11__);

/**
* @name skewness
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/skewness}
*/
setReadOnly( frechet, 'skewness', __var_12__);

/**
* @name stdev
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/stdev}
*/
setReadOnly( frechet, 'stdev', __var_13__);

/**
* @name variance
* @memberof frechet
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/frechet/variance}
*/
setReadOnly( frechet, 'variance', __var_14__);


// EXPORTS //
export default frechet;

export { __var_1__ as cdf, __var_2__ as Frechet, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mode, __var_10__ as pdf, __var_11__ as quantile, __var_12__ as skewness, __var_13__ as stdev, __var_14__ as variance};